export default __webpack_public_path__ + "static/media/products02.c96eaf6f.jpg";